(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lulu-growth"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    function preferences(root){root.querySelectorAll('[data-ll-growth] form[action*="/contact"]').forEach(form=>{const tags=form.querySelector('[data-ll-tags]');if(!tags||form.dataset.llBound)return;form.dataset.llBound='1';const sync=()=>{tags.value=['newsletter','ll-news','ll-character-'+form.querySelector('[data-ll-character]').value,'ll-language-'+form.querySelector('[data-ll-language]').value].join(',');};form.addEventListener('change',sync);form.addEventListener('submit',sync);sync();});}
    preferences(document);document.addEventListener('shopify:section:load',event=>preferences(event.target));
    if(customElements.get('lulu-shipping'))return;
    customElements.define('lulu-shipping',class extends HTMLElement{
      connectedCallback(){this.config=JSON.parse(this.querySelector('[data-ll-shipping-config]').textContent);this.paint(this.config.cart);if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){this.unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{if(event.cartData)this.paint(event.cartData);});}}
      disconnectedCallback(){if(this.unsubscribe)this.unsubscribe();}
      paint(cart){const c=this.config,message=this.querySelector('[data-ll-shipping-message]'),bar=this.querySelector('progress'),estimate=this.querySelector('[data-ll-estimate]');this.hidden=!cart.item_count;if(!cart.item_count)return;bar.hidden=true;estimate.hidden=true;
        const discountNames=(cart.cart_level_discount_applications||[]).map(d=>d.title||'').concat((cart.discount_codes||[]).filter(d=>d.applicable).map(d=>d.code||''));if(discountNames.some(n=>/LULUFAMILY10|LULUCOMEBACK10/i.test(n))){message.textContent=c.blocked;return;}
        const currency=cart.currency||c.currency;if(currency!==c.currency){message.textContent=c.unknown;return;}let rate=currency===c.base?1:Number(window.Shopify?.currency?.rate);if(!(rate>0)||!Number.isFinite(rate)){message.textContent=c.unknown;return;}
        const threshold=Math.ceil(10000*rate),subtotal=Number(cart.total_price);const remaining=Math.max(0,threshold-subtotal);const amount=new Intl.NumberFormat(c.locale,{style:'currency',currency,currencyDisplay:'code'}).format(remaining/100);message.textContent=remaining?c.more.replace('[amount]',amount):c.met;bar.hidden=false;bar.max=threshold;bar.value=Math.min(subtotal,threshold);bar.setAttribute('aria-label',c.title);estimate.hidden=currency===c.base;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lulu-localization"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const form=document.getElementById('LLLocalizationForm');
  if(!form||form.dataset.bound||form.querySelector('[data-ll-editor-mismatch]')?.value==='true')return;form.dataset.bound='1';
  const country=form.elements.country_code,language=form.elements.language_code;
  const map={TW:'zh-TW',HK:'zh-TW',JP:'ja',KR:'ko',US:'en',AU:'en',CA:'en',CN:'zh-CN',GB:'en',MY:'en',SG:'en'};
  const manualKey='ll_localization_manual_v4';let interacting=false,controller;
  const supported=(select,value)=>Array.from(select.options).some(o=>o.value===value);
  const setLanguage=code=>{const desired=map[code]||'en';if(supported(language,desired))language.value=desired;};
  const remember=()=>{interacting=true;controller?.abort();form.dataset.geoStatus='manual';try{sessionStorage.setItem(manualKey,String(Date.now()+30*60*1000));}catch(e){}};
  form.addEventListener('change',event=>{remember();if(event.target===country)setLanguage(country.value);form.requestSubmit();});
  const prepareOtherForm=(target,code)=>{if(!target||target===form||!target.elements.country_code)return;remember();const desired=map[code]||'en';if(!supported(language,desired))return;let input=target.querySelector('[name="language_code"]');if(!input){input=document.createElement('input');input.type='hidden';input.name='language_code';target.appendChild(input);}input.value=desired;};
  document.addEventListener('click',event=>{const option=event.target.closest('localization-form a[data-value]');if(option)prepareOtherForm(option.closest('form'),option.dataset.value);},true);
  document.addEventListener('submit',event=>{if(event.target.matches('form[action*="/localization"]'))prepareOtherForm(event.target,event.target.elements.country_code?.value);if(event.target!==form){interacting=true;controller?.abort();}},true);
  document.addEventListener('click',event=>{if(event.target.closest('#cart-icon-bubble,[name="checkout"],.cart__checkout-button')){interacting=true;controller?.abort();}},true);
  if(window.Shopify?.designMode||/\/(cart|checkout|checkouts|account)(\/|$)/.test(location.pathname))return;
  try{if(Number(sessionStorage.getItem(manualKey)||0)>Date.now()){form.dataset.geoStatus='manual';return;}}catch(e){}
  form.dataset.geoStatus='detecting';
  const apply=data=>{
    if(interacting)return;
    const detected=data.detected_values?.country?.handle;
    const suggestion=(data.suggestions||[]).find(s=>s.parts?.country?.handle)?.parts?.country?.handle;
    const code=detected||suggestion;
    if(!code||!supported(country,code)){form.dataset.geoStatus='unsupported';return;}
    form.dataset.detectedCountry=code;
    const previous=language.value;setLanguage(code);
    form.dataset.geoStatus='matched';
    if(code===country.value&&previous===language.value)return;
    try{
      const previousAttempt=JSON.parse(sessionStorage.getItem('ll_geo_redirect_v4')||'null');
      if(previousAttempt?.code===code&&Date.now()-previousAttempt.at<15000){form.dataset.geoStatus='redirect-not-applied';return;}
      sessionStorage.setItem('ll_geo_redirect_v4',JSON.stringify({code,at:Date.now()}));
    }catch(e){}
    country.value=code;form.dataset.geoStatus='redirecting';form.requestSubmit();
  };
  const detect=async attempt=>{
    controller=new AbortController();const timer=setTimeout(()=>controller.abort(),8000);
    try{
      const root=window.Shopify?.routes?.root||'/';
      const response=await fetch(root+'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true',{credentials:'same-origin',cache:'no-store',signal:controller.signal});
      if(!response.ok)throw Error('Localization unavailable');
      apply(await response.json());
    }catch(e){
      if(interacting)return;
      if(attempt===0){clearTimeout(timer);await detect(1);}
      else form.dataset.geoStatus='unavailable';
    }finally{clearTimeout(timer);}
  };
  detect(0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lulu-market"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('#LuluCountry option').forEach(option=>{const code=option.value;if(/^[A-Z]{2}$/.test(code))option.textContent=String.fromCodePoint(...[...code].map(c=>127397+c.charCodeAt(0)))+' '+option.textContent;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyou-image-compare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zyou-image-compare')) {
  customElements.define('zyou-image-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('input[type="range"]');
      const update = () => this.style.setProperty('--position', `${Math.max(0, Math.min(100, Number(input.value)))}%`);
      input.addEventListener('input', update);
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
